import { render } from "./SliderJobs.vue?vue&type=template&id=764438b6"
import script from "./SliderJobs.vue?vue&type=script&lang=js"
export * from "./SliderJobs.vue?vue&type=script&lang=js"
script.render = render

export default script